import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { useProductModalDescriptionStyles } from './styles';
import { formatDateForGiftCards } from '../../../../../../helpers/DateFormatter';

const ProductDescription = ({ ...props }) => {
  const { product, newExchange, isGiftCard } = props;
  const classes = useProductModalDescriptionStyles();

  return (
    <>
      <Box display="flex" flexDirection="column" justifyContent="space-between">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-around"
        >
          <Typography className={classes.text} variant="h6">
            {product.title}
          </Typography>
          <Typography className={classes.date} variant="h6">
            Fecha de emisión: {formatDateForGiftCards(newExchange.createdAt)}
          </Typography>
        </Box>
      </Box>
      {isGiftCard && (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-around"
          >
            <Typography className={classes.dateEnd} variant="h6">
              Fecha de vencimiento:{' '}
              {formatDateForGiftCards(newExchange.expirationDate)}
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
};

ProductDescription.propTypes = {
  product: PropTypes.object,
  newExchange: PropTypes.object,
  isGiftCard: PropTypes.bool,
};

export default ProductDescription;
